<template>
  <div>
    <b-loading :active.sync="isLoading" :is-full-page="true"></b-loading>

    <div>
      <div class="title">Change current Tenant Id (this session only)</div>

      <b-field grouped style="margin-left: 30%; margin-top: 50px">
        <b-select
            v-model="tenantId"
            placeholder="Tenants"
            size="is-large"
        >
          <option
              v-for="(option, index) in tenants"
              :key="index"
              :value="option.code">
            {{ option.code }} ({{ option.title }})
          </option>
        </b-select>

        <b-button :disabled="isLoading" class="button is-primary" size="is-large"
                  @click.prevent="updateSessionTenantId">Update the tenant Id
        </b-button>
      </b-field>
    </div>

    <div>
      <b-field style="text-align: center; margin-top: 40px; margin-bottom: 40px">
        <b-button class="button is-light btn-margin" @click.prevent="goToPreviousPage()">Back to Admin</b-button>

      </b-field>
    </div>
  </div>

</template>

<script>
import adminService from '../services/adminService'
import displayHelper from '../helpers/display-helper'
import {metro} from '../main'
import tenantService from '@/services/tenantsService'

export default {
  name: 'authToken-form',
  created() {
    this.tenantId = this.$store.state.apiKey.split('_')[0]
    this.loadTenantList()

    console.log(this.tenantId)
  },
  data() {
    return {
      isLoading: false,
      tenantId: '',
      tenants: [],
    }
  },
  methods: {
    loadTenantList() {
      const parent = this
      this.isLoading = true

      tenantService.getTenants()
          .then((tenants) => {
                this.tenants = tenants
              },
              (err) => {
                this.isError = true
                displayHelper.displayError(parent, 'Oops, the tenants could not be listed: ' + err.message)
              })
          .finally(() => {
            this.isLoading = false
          })
    },
    updateSessionTenantId() {
      this.isLoading = true
      const parent = this

      adminService.updateSessionTenantId(this.tenantId)
          .then((authToken) => {
            this.$store.commit('SET_API_KEY', authToken.token)
            metro.$emit('api_key_updated', authToken.token)

            this.goToPreviousPage()
          })
          .catch((error) => {
            displayHelper.displayError(parent, 'Update updateSessionTenantId error: id=' + this.tenantId + ' >>' + error.message)
          })
          .finally(() => {
            this.isLoading = false
          })
    },
    goToPreviousPage() {
      this.$router.push({name: 'Admin'})
    },
  },
}
</script>

<style scoped>
.authToken .is-horizontal .field-label {
  flex-grow: 0;
}

.authToken label {
  margin-bottom: 0;
  width: 180px !important;
}

.authToken .column .field {
  align-items: center;
}

.field-label {
  flex-grow: 0;
}

.field-label label {
  width: 180px !important;
}
</style>
